export default {
	state : {
		updateListFun : () => {},
		updatePlanListFun : () => {},
		recordSrolllTop:0,// 记录滚动位置 新规划订货
		orderNewPlanSearch:{},// 新规划订货的筛选
	},
	mutations : {
		setUpdateListFun(state, payload) {
			if(typeof payload !== 'function'){
				throw new Error('updateListFun mast be function');
			} else {
				state.updateListFun = payload;
			}
		},
		setUpdatePlanListFun(state, payload) {
			if(typeof payload !== 'function'){
				throw new Error('updateListFun mast be function');
			} else {
				state.updatePlanListFun = payload;
			}
		},
		changeOrderNewPlanSearch(state, payload) {
			state.orderNewPlanSearch = payload;
		},
		changeRecordSrolllTop(state, payload) {
			state.recordSrolllTop = payload;
		},
	},
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/submitOrder.js